import React from 'react';
import styled from 'styled-components';

import {
	AbbreviatedTitleField,
	TitleSecurityField,
	DefaultLocalizedInfo,
	ReleaseYearField,
	TitleId,
	TitleStatusField,
	WorkTypeDetails,
	OriginalLanguages,
	UltraMezzId,
	ExportMECButton,
	DeleteTitleButton,
} from '@warehouse/title/feature-title-settings';

import { isFeatureEnabledForCurrentTenant } from '@warehouse/shared/config';

import { TitleFull } from '@warehouse/title/core';

import { ContentWrapper, Row, SharedRow } from './style';
import TitleType from './TitleType';
import { PrimaryParent } from './PrimaryParent';
import ExportMMCButton from './ExportMMCButton';

interface GeneralTabProps {
	data?: TitleFull;
}

const ExportButtonWrapper = styled.div(
	({ theme }) => `
		display: flex;
		gap: ${theme.spacing(1)};
	`,
);

export function GeneralTab({ data }: GeneralTabProps) {
	return (
		<>
			<ContentWrapper>
				<TitleId />
				<UltraMezzId />

				<Row>
					<TitleType title={data} />
					<WorkTypeDetails />
				</Row>

				<Row>
					<TitleStatusField />
					<ReleaseYearField />
				</Row>

				<Row>
					<DefaultLocalizedInfo />
				</Row>

				<Row>
					<AbbreviatedTitleField />
				</Row>

				<Row>
					<TitleSecurityField />
				</Row>

				{data && <PrimaryParent title={data} />}

				<OriginalLanguages />
			</ContentWrapper>

			<ExportButtonWrapper>
				<SharedRow style={{ marginTop: '14px', width: '100%' }}>
					<ExportMECButton />

					{isFeatureEnabledForCurrentTenant('title-settings-export-mmc-xml-button') && <ExportMMCButton />}
				</SharedRow>

				{data?.uuid && <DeleteTitleButton uuid={data.uuid} />}
			</ExportButtonWrapper>
		</>
	);
}
